<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav class="sidebar fixed top-0 bottom-0 z-50 h-full min-h-screen w-[280px] m-2.5 lg:m-0 transition-all duration-300">
        <div class="lg:h-full bg-white rounded-xl lg:rounded-none dark:bg-[#102030]">
            <div class="flex items-center justify-between px-4 py-3">
                <a routerLink="/" class="main-logo flex gap-3 shrink-0 items-center">
                    <img class="ml-[5px] w-8 flex-none" src="/assets/images/logo.png" alt="" />
                    <span class="logo-text align-middle text-2xl font-light ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light lg:inline">Brickhub</span>
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <svg class="m-auto h-5 w-5" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            opacity="0.5"
                            d="M16.9998 19L10.9998 12L16.9998 5"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 p-4 py-0 font-normal">
                    <li class="nav-item">
                        <a routerLink="/dashboard" class="group" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-dashboard class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Dashboard' | translate }}</span>
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/properties" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-widgets class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Properties' | translate }}</span>
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/shortlisted-properties" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-documentation class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Shortlisted Property' | translate }}</span>
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/my-quotation" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-invoice class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'My Quotation' | translate }}</span>
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/site-visits" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-contacts class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Site Visit' | translate }}</span>
                            </div>
                        </a>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('property-bookings') }"
                            (click)="onPropertyBookingsMenuClick()"
                        >
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Property Bookings' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('property-bookings') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('property-bookings')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a
                                        routerLink="/property-bookings/bookings"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()"
                                        >{{ 'Bookings' | translate }}</a
                                    >
                                </li>
                                <li>
                                    <a routerLink="/property-bookings/loans" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'Loans' | translate
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        routerLink="/property-bookings/property-registrations"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()"
                                        >{{ 'Property Registrations' | translate }}</a
                                    >
                                </li>
                                <li>
                                    <a
                                        routerLink="/property-bookings/demand-letters-payments"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()"
                                        >{{ 'Demand Letters & Payments' | translate }}</a
                                    >
                                </li>
                                <li>
                                    <a routerLink="/property-bookings/documents" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'Documents' | translate
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/work-progress" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-charts class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Work Progress' | translate }}</span>
                            </div>
                        </a>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('post-sales') }"
                            (click)="toggleAccordion('post-sales')"
                        >
                            <div class="flex items-center">
                                <icon-menu-chat class="shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Post Sales Activities' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('post-sales') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('post-sales')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/post-sales/key-handover" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'Key Handover' | translate
                                    }}</a>
                                </li>
                                <li>
                                    <a routerLink="/post-sales/customer-queries" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'Customer Queries' | translate
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>
